import { configureStore } from "@reduxjs/toolkit";
import VenueList from "./LMS_Slices/Masters/VenueList";
import UserList from "./LMS_Slices/Masters/UserList";
import GroupList from "./LMS_Slices/Masters/GroupList";
import AnnouncementList from "./LMS_Slices/Masters/AnnouncementList";
import DepartmentList from "./LMS_Slices/Assets/DepartmentList";
import PollList from "./LMS_Slices/Masters/PollList";
import GroupDetails from "./LMS_Slices/Masters/GroupDetails";
import Dashboard from "./LMS_Slices/Dashboard/Dashboard";
import QuizMarksList from "./LMS_Slices/Masters/QuizMarksList";
import CourseList from "./LMS_Slices/Course/CourseList";
import GroupCountData from "./LMS_Slices/Masters/GroupCountData";
import QuestionList from "./LMS_Slices/Quiz/QuestionList";
import QuestionDetails from "./LMS_Slices/Quiz/QuestionDetails";
import QuizList from "./LMS_Slices/Quiz/QuizList";
import FolderList from "./LMS_Slices/FileLibrary/FolderList";
import FilesList from "./LMS_Slices/FileLibrary/FilesList";
import QuizDetails from "./LMS_Slices/Quiz/QuizDetails";
import CourseDetails from "./LMS_Slices/Course/CourseDetails";
import ArchiveCourseList from "./LMS_Slices/Course/ArchiveCourseList";
import PollData from "./LMS_Slices/Assets/PollData";
import LearningTrackList from "./LMS_Slices/Course/LearningTrackList";
import GetUserWise from "./LMS_Slices/Assets/GetUserWise";
import TrackDetails from "./LMS_Slices/Course/TrackDetails";
import InstructorList from "./LMS_Slices/Assets/InstructorList";
import TrainingList from "./LMS_Slices/Course/TrainingList";
import TrainingDetails from "./LMS_Slices/Course/TrainingDetails";
import RoleList from "./LMS_Slices/Assets/RoleList";
import CourseQuiz from "./LMS_Slices/Course/CourseQuiz";
import StartQuiz from "./LMS_Slices/Course/StartQuiz";
import QuizTimer from "./LMS_Slices/Course/QuizTimer";
import GetCourseTimer from "./LMS_Slices/Course/GetCourseTimer";
import AttendanceUserList from "./LMS_Slices/Course/AttendanceUserList";
import NotesList from "./LMS_Slices/Course/NotesList";
import MessageList from "./LMS_Slices/Messages/MessageList";
import QuizResult from "./LMS_Slices/Course/QuizResult";
import LearnerCourseList from "./LMS_Slices/Course/LearnerCourseList";
import FeedbackQuestion from "./LMS_Slices/Feedback/FeedbackQuestion";
import LearnerCourseDetails from "./LMS_Slices/Course/LearnerCourseDetails";
import FeedbackList from "./LMS_Slices/Feedback/FeedbackList";
import FeedbackDetails from "./LMS_Slices/Feedback/FeedbackDetails";
import LearnerDashboard from "./LMS_Slices/Dashboard/LearnerDashboard";
import ActiveLogins from "./LMS_Slices/Dashboard/ActiveLogins";
import CertificateList from "./LMS_Slices/Certificate/CertificateList";
import ExternalTrainingList from "./LMS_Slices/Course/ExternalTrainingList";
import EnrollCourseList from "./LMS_Slices/Course/EnrollCourseList";
import TrainingType from "./LMS_Slices/Course/TrainingType";
import LearnerBadge from "./LMS_Slices/Dashboard/LearnerBadge";
import LeaderBoardPoints from "./LMS_Slices/LeaderBoard/LeaderBoardPoints";
import PointsDetails from "./LMS_Slices/LeaderBoard/PointsDetails";
import ReportList from "./LMS_Slices/Report/ReportList";
import Notification from "./LMS_Slices/Notification/Notification";
import TemplateList from "./LMS_Slices/Certificate/TemplateList";
import UserListByCourse from "./LMS_Slices/Course/UserListByCourse";
import NotificationDetails from "./LMS_Slices/Notification/NotificationDetails";
import AuditTrailList from "./LMS_Slices/Report/AuditTrailList";
import AuditReportList from "./LMS_Slices/Report/AuditReportList";
import FinYearList from "./LMS_Slices/Hr/FinYearList";
import AttendanceStatusList from "./LMS_Slices/Hr/AttendanceStatusList";
import LeaveStatusList from "./LMS_Slices/Hr/LeaveStatusList";
import LeaveTypeList from "./LMS_Slices/Hr/LeaveTypeList";
import SalaryList from "./LMS_Slices/Hr/SalaryList";
import AttendanceHistoryList from "./LMS_Slices/Hr/AttendanceHistoryList";

const LMS_STORE = configureStore({
    reducer: {
        dashboard: Dashboard,
        pollData: PollData,
        venueList: VenueList,
        userList: UserList,
        groupList: GroupList,
        groupDetails: GroupDetails,
        announcementList: AnnouncementList,
        depratmentList: DepartmentList,
        pollList: PollList,
        quizMarksList: QuizMarksList,
        courseList: CourseList,
        courseDetails: CourseDetails,
        archiveCourseList: ArchiveCourseList,
        groupCountData: GroupCountData,
        questionList: QuestionList,
        questionDetails: QuestionDetails,
        quizList: QuizList,
        folderList: FolderList,
        fileList: FilesList,
        quizDetails: QuizDetails,
        learningTrackList: LearningTrackList,
        getUserWise: GetUserWise,
        trackDetails: TrackDetails,
        instructorList: InstructorList,
        trainingList: TrainingList,
        trainingDetails: TrainingDetails,
        roleList: RoleList,
        courseQuiz: CourseQuiz,
        startQuiz: StartQuiz,
        quizTimer: QuizTimer,
        getCourseTimer: GetCourseTimer,
        attendanceUserList: AttendanceUserList,
        notesList: NotesList,
        messageList: MessageList,
        quizResult: QuizResult,
        learnerCourseList: LearnerCourseList,
        feedbackQuestion: FeedbackQuestion,
        learnerCourseDetails: LearnerCourseDetails,
        feedbackList: FeedbackList,
        feedbackDetails: FeedbackDetails,
        learnerDashboard: LearnerDashboard,
        activeLogins: ActiveLogins,
        certificateList: CertificateList,
        externalTrainingList: ExternalTrainingList,
        enrollCourseList: EnrollCourseList,
        trainingType: TrainingType,
        learnerBadge: LearnerBadge,
        leaderBoardPoints: LeaderBoardPoints,
        pointsDetails: PointsDetails,
        reportList: ReportList,
        notification: Notification,
        templateList: TemplateList,
        userListByCourse: UserListByCourse,
        notificationDetails: NotificationDetails,
        auditTrailList: AuditTrailList,
        auditReportList: AuditReportList,
        finYearList: FinYearList,
        attendanceStatusList: AttendanceStatusList,
        leaveStatusList: LeaveStatusList,
        leaveTypeList: LeaveTypeList,
        salaryList: SalaryList,
        attendanceHistoryList: AttendanceHistoryList,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export default LMS_STORE;